/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsParallaxFullWidthImageAndColorViewProps } from '../../../modules/hosports-parallax-full-width-image-and-color/./hosports-parallax-full-width-image-and-color';

export default (props: IHosportsParallaxFullWidthImageAndColorViewProps) => {
  let config = props.config;
  console.log(config)
  return (
      <div>{'todo'}</div>
  );
};
